import { useState } from "react"
import MenuBar from './ui/menuBar/MenuBar'
import styles from './visualization-dropdown/Alert.module.scss'

const AlertMenu = ({menuItems, alert}) => {
    const [anchorEl, setAnchorEl] = useState(null)
     return (<div className={styles["menu-bar"]}>
        <MenuBar key={alert.uuid} setAnchorEl={setAnchorEl} anchorEl={anchorEl}>
            {menuItems(alert, setAnchorEl)}
        </MenuBar>
    </div>)
}

export default AlertMenu